<div class="inner-page-wrapper">
    <span class="text-14 text-grey-400 leading-21">
        <sup>{{ safeData().sign }}</sup>
        &nbsp;
    </span>
    <span class="text-14 text-grey-400 leading-21" [innerHTML]="safeData().text"></span>
</div>
